import Vue from 'vue';
import Router from 'vue-router';
import Home from '@/components/Home';
import Layouts from '@/components/layout/Layouts';
import Events from '@/components/events/Events';
import Booking from '@/components/booking/Booking';
import Settings from '@/components/settings/Settings';
import Login from "../components/Login";
import {store} from "../store/store"

Vue.use(Router);

let router = new Router({
  mode: 'history',
  base: process.env.BOOKIE_BASE,
  routes: [
    {
      path: '/',
      name: 'home',
      component: Home,
      meta: {
        requiresAuth: true
      }
    },
    {
      path: '/layouts',
      name: 'layouts',
      component: Layouts,
      // props: true
      meta: {
        requiresAuth: true
      }
    },
    {
      path: '/events',
      name: 'events',
      component: Events,
      meta: {
        requiresAuth: true
      }
    },
    {
      path: '/integrated-booking',
      name: 'integrated-booking',
      meta: { layout: 'no-sidebar' },
      component: Booking,
      props: (route) => ({
        eventId: route.query.eid,
        deviceId: route.query.dcid,
        numSeats: route.query.numseats,
        strSeatIds: route.query.seats,
        channel: route.query.ch,
        strRules: route.query.rule,
        happySeatBenchMark: route.query.hsbm
      })
    },
    {
      path: '/settings/seat-recommendation-rules',
      name: 'seat-recommendation-rules',
      component: Settings,
      meta: {
        requiresAuth: true
      }
    },
    {
      path: '/login',
      name: 'login',
      meta: { layout: 'login' },
      component: Login
    }
  ]
});

router.beforeEach((to, from, next) => {
  if(to.matched.some(record => record.meta.requiresAuth)) {
    if (store.getters.isLoggedIn) {
      next();
      return;
    }
    next('/login');
  } else {
    next();
  }
});

export default router;



// WEBPACK FOOTER //
// ./src/router/index.js